// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__WDYxM","col":"styles_col__7ao05"};